<template>
  <div class="wrapper">
    <div class='container'>
			<!-- <logo><img src="/static/logo.png"></logo> -->
			<div class="login">
				<div class="adBox">
					<div class="ad"></div>
				</div>
				<div class="form" >
					<div class="title">
						<div class="tabs active">账号登录</div>
						<div class="tabs">&nbsp;&nbsp;&nbsp;   </div>
					</div>
					<div class="content">
						<div class="formRow"><input type="text" v-model="form.loginName" class="text user" placeholder="请输入账号或手机号码" /></div>
						<div class="formRow"><input type="password" v-model="form.password" class="text pwd" placeholder="请输入密码" /></div>
						<div class="formRow">
							
							<div class="remember"><input type="checkbox" v-model="remember"> 记住用户名/密码</div>
						</div>
						<div class="formRow">
              <el-button type="primary" @click="submit" :loading="loading" style="width:100%;height:50px;border:0;border-radius:5px;background:#15A7FB;font-size:20px;color:#FFF;">登录</el-button>

            </div>
					</div>
					
				</div>
        <!-- <div class="div_foot">
          &copy; 2023 lanhaidata.com  海南省斯迈尔电子科技有限公司 版权所有 经营性备案号：琼B2-20030019
        </div> -->
				<div class="info">© 2023 lanhaidata.com <span >海南省斯迈尔电子科技有限公司</span> 版权所有 <br/>经营性备案号：琼B2-20030019</div>
			</div>
		</div>
		<div></div>
  </div>
</template>

<style scoped>
  .wrapper{height:100%;overflow:hidden;}
.wrapper{
margin:0;padding:0;font-family:"microsoft yahei";font-size:14px;
background:url(/static/bg1.jpg) top center no-repeat;background-size:cover;}
.container{width:90%;height:auto;max-width:1200px;margin:0 auto;}
logo{margin-top:80px;display:block; font-size: 2rem; color: #ffffff;}
logo img{height:80px;}
.login{position:relative;}
.adBox{width:560px;height:560px;margin-top:60px;float:left;position:relative;}
.ad{width:500px;height:500px;background:url(/static/ad.png) top center no-repeat;position:absolute;left:30px;top:30px;}
.form{width:310px;height:380px;border-radius:5px;background:rgba(25,25,25,0.7);margin-top:130px;padding:20px;float:right;}
.tabs{width:50%;float:left;text-align:center;font-size:16px;color:#FFF;line-height:50px;border-bottom:1px solid #FFF;cursor:pointer;}
.title:after{content:"";display:block;clear:both;}
.active{color:#02E6E9;}
.content{padding:20px 0;}
.code{width:200px;margin:30px auto;}
.codeText{color:#FFF;font-size:12px;text-align:center;}
.hide{display:none;}
.formRow{width:100%;margin:25px 0;}
.formRow input.text{width:80%;padding:0 5% 0 15%;height:50px;border:0;border-radius:5px;font-size:18px;}
.formRow input.user{background:#FFFFFF url(/static/user.png) left center no-repeat;}
.formRow input.pwd{background:#FFFFFF url(/static/pwd.png) left center no-repeat;}
.formRow input.btn{width:100%;height:50px;border:0;border-radius:5px;background:#15A7FB;font-size:20px;color:#FFF;}
.formRow:after{content:"";display:block;clear:both;}
.tip{float:left;width:50%;}
.tip .ico{width:20px;height:20px;border-radius:50%;background:#F3B903;color:#fff;text-align:center;line-height:20px;display:inline-block;cursor:pointer;}
.tip .text{margin-left:10px;color:#FFFFFF;}
.remember{width:150px;float:right;color:#FFFFFF;}
.div_foot {
      color: #ffffff; 
      font-size: 1.3rem;
      position: absolute;
      height: 50px;
      bottom: 0;
      text-align: center;
      line-height: 50px;
      width: 100%;
  }
.info{position:absolute;margin-top: 36rem; color: GhostWhite;
   font-size: 1rem; text-align: center; 
   width:100%;height:50px;}
@media (max-width:991px){.adBox{display:none;}.form{width:90%;margin:100px auto; font-size: 2rem; float:none;}}
@media (max-height:768px){logo{margin-top:20px;}.adBox{margin-top:20px;}.form{margin-top:80px;}.info{top:80px;}.container{transform:scale(0.9);}}
</style>
<script>
  import HomeApi from '@/api/home'
  import Utils from '@/utils/utils'

  export default {
    data() { return {
      loading: false,
      title: document.title,
      remember: false,
      form: {loginName: '', password: ''},
      rules: {
          loginName: [
            { required: true, message: '请输入账号或手机号码', trigger: 'blur' },
            //{ min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '请输入密码', trigger: 'blur' }
          ],
        }
    }},
    created() {
      let loginInfo = Utils.getStore('login')
      if (loginInfo) {
        this.form = JSON.parse(loginInfo)
        this.remember = true
      }
    },
    mounted() {
      // this.$refs.loginName.focus()
    },
    methods: {
      // 登录
      async submit() {
        // try { await this.$refs.form.validate() } catch(e){ return }
        if(!this.form.loginName) {
          this.$message.error('请输入用户名!')
          return;
        }
        if(!this.form.password) {
          this.$message.error('请输入密码!')
          return;
        }
        this.loading = true
        const apiRes = (await HomeApi.login(this.form)).data
        this.loading = false
        // 登录成功
        if (apiRes.status == 0) {
          if (this.remember) {
            Utils.setStore('login', JSON.stringify(this.form))
          } else {
            Utils.removeStore('login')
          }
          // 将登录用户信息存入store
          this.$store.commit('login', apiRes.data)
          // 跳转到首页
          this.$router.push('/')
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/login.vue